import classNames from "classnames";
import React from "react";
import styles from "./DisplayTreeStyles.module.css";

export const DisplayTreeDivider = () => {
  return <div className={classNames(styles["divider-container"])}>|</div>;
};
